
export const SET_CATEGORIES = 'SET_CATEGORIES';
export const SET_SELECTED_LIBRARY = 'SET_SELECTED_LIBRARY';
export const CLEAR_LIBRARY = 'CLEAR_LIBRARY';


const setCategories = (categories) => ({
    type: SET_CATEGORIES,
    categories
});

const setSelectedLibrary = (library, libraryType) => ({
    type: SET_SELECTED_LIBRARY,
    library,
    libraryType
});

const clearLibrary = () => ({
    type: CLEAR_LIBRARY,
});

export const setCategoriesFromLibraries = (categories) => async dispatch => {

    try {
        dispatch(setCategories(categories));
    } catch (error) {

    }
};

export const clearLibraryFromLibraries = () => async dispatch => {

    try {
        dispatch(clearLibrary());
    } catch (error) {

    }
};

export const setSelectedLibraryFromLibraries = (library, type) => async dispatch => {
    try {
        dispatch(setSelectedLibrary(library, type));
    } catch (error) {

    }
};



// WEBPACK FOOTER //
// ./src/actions/library.js